import { Skeleton } from 'antd';
import styles from './index.module.less';
import { HomeArticleModel } from '@/types/home';
import { useRouter } from 'next/router';
import { imgUrl } from '@/shared/utils';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { useIsMobile } from '@/hooks/useIsMobile';

const HomeFullItem = ({
  articleModel,
  showBottomLine = true,
  showPadding = true,
}: {
  articleModel?: HomeArticleModel;
  showBottomLine?: boolean;
  showPadding?: boolean;
}) => {
  const router = useRouter();
  const isMobile = useIsMobile();

  const getlink = `/blog/${articleModel?.title_id}`;

  const onClick = () => {
    if (articleModel?.title_id != undefined) {
      router.push(getlink);
    }
  };

  // ✅ 判断是否有封面图
  const hasCoverImage = articleModel != null && articleModel?.cover_image !== null;

  // 图片加载状态
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  // 根据是否为移动端计算 padding
  const basePadding = isMobile ? '24px' : '42px';
  const containerPadding = showPadding ? basePadding : `${basePadding} 0`;

  return (
    <>
      {/* ✅ 使用 CSS Grid 替代 Ant Design Row/Col */}
      <div
        className={`${styles.mainContainer} ${hasCoverImage ? styles.withImage : styles.noImage}`}
        style={{
          borderBottom: showBottomLine ? '1px solid rgba(68, 68, 68, 0.2)' : undefined,
          cursor: 'pointer',
          padding: containerPadding,
        }}
        onClick={onClick}
      >
        <div className={styles.textContent}>
          {articleModel == null ? (
            <Skeleton active />
          ) : (
            <>
              <Link href={getlink}>
                <h2 className={styles.titleContainer}>{articleModel?.title}</h2>
              </Link>
              <p className={styles.descContainer}>{articleModel?.description}</p>
              <div className={styles.timeContainer}>{articleModel?.create_time}</div>
            </>
          )}
        </div>
        {hasCoverImage && (
          <div className={styles.imageContent}>
            {articleModel == null ? (
              <Skeleton.Image active />
            ) : (
              <div className={styles.imageWrapper}>
                {/* 加载中的骨架屏 */}
                {imageLoading && !imageError && (
                  <div className={styles.imagePlaceholder}>
                    <div className={styles.shimmer}></div>
                  </div>
                )}

                {/* 加载失败的占位图 */}
                {imageError && (
                  <div className={styles.imageErrorPlaceholder}>
                    <svg className={styles.brokenImageIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 5v6.59l-2.29-2.3a1 1 0 0 0-1.42 0L14 12.59 10.71 9.3a1 1 0 0 0-1.42 0L3 15.59V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2zM5 21a2 2 0 0 1-2-2v-.41l6.29-6.3 3.3 3.3a1 1 0 0 0 1.42 0L17.3 12.3l3.7 3.7V19a2 2 0 0 1-2 2H5z" fill="currentColor" />
                      <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" />
                      <line x1="3" y1="3" x2="21" y2="21" stroke="currentColor" strokeWidth="2" />
                    </svg>
                    <span className={styles.errorText}>加载失败</span>
                  </div>
                )}

                {/* 实际图片 */}
                <Image
                  className={styles.imgContainer}
                  src={imgUrl(articleModel?.cover_image, 'mid')}
                  alt={articleModel.title}
                  width={294}
                  height={165}
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    opacity: imageLoading || imageError ? 0 : 1,
                    transition: 'opacity 0.3s ease-in-out',
                    display: 'block',
                  }}
                  onLoad={() => setImageLoading(false)}
                  onError={() => {
                    setImageLoading(false);
                    setImageError(true);
                  }}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default HomeFullItem;
